/* ============
 * Vuex Actions
 * ============
 *
 * All the actions that can be used
 * inside the store
 */
import * as types from './mutation-types';

// Profile
export const getAccount = ({ commit }, account) => {
  commit(types.GET_ACCOUNT, account);
};

export const getAddress = ({ commit }, address) => {
  commit(types.GET_ADDRESS, address);
};

export const getContact = ({ commit }, contact) => {
  commit(types.GET_CONTACT, contact);
};

export const getOrganizationSettings = ({ commit }, settings) => {
  commit(types.GET_ORGANIZATION_SETTINGS, settings);
};

export const getPublicProfile = ({ commit }, publicProfile) => {
  commit(types.GET_PUBLIC_PROFILE, publicProfile);
};

// Provider
export const setSelectedProvider = ({ commit }, selectedProvider) => {
  commit(types.SELECTED_PROVIDER, selectedProvider);
};

export const setDownloadProviderList = ({ commit }, providerList) => {
  commit(types.DOWNLOAD_PROVIDER_LIST, providerList);
};

export const setClientProvider = ({ commit }, clientProviderItem) => {
  commit(types.CLIENT_PROVIDER, clientProviderItem);
};


export const setNewProviderItemList = ({ commit }, newPproviderList) => {
  commit(types.ADD_NEW_DOWNLOAD_PROVIDER_LIST, newPproviderList);
};

export const setNewClientProvider = ({ commit }, newPproviderList) => {
  commit(types.ADD_NEW_DOWNLOAD_PROVIDER_LIST, newPproviderList);
};

// Auth
export const setMaintenanceMode = ({ commit }, status) => {
  commit(types.SET_MAINTENANCE_MODE, status);
};

export const login = ({ commit }, token) => {
  commit(types.LOGIN, token);
};

export const logout = ({ commit }) => {
  commit(types.RESET_PROFILE);
  commit(types.RESET_CLIENTS);
  commit(types.RESET_CLIENT_GROUPS);
  commit(types.RESET_PRODUCTS);
  commit(types.RESET_PRODUCT_GROUPS);
  commit(types.RESET_ORDERS);
  commit(types.RESET_ORDER_PRODUCTS);
  commit(types.RESET_CREDIT_NOTE_PRODUCTS);
  commit(types.RESET_BILL_PRODUCTS);
  commit(types.RESET_BILLS);
  commit(types.LOGOUT);
};

export const checkAuthentication = ({ commit }) => {
  commit(types.CHECK_AUTHENTICATION);
};

export const twoFactorVerification = ({ commit }, { token, userId, verificationType, mobileNumber }) => {
  commit(types.TWO_FACTOR_VERIFICATION, {
    token,
    userId,
    verificationType,
    mobileNumber,
  });
};

export const checkTwoFactorVerification = ({ commit }) => {
  commit(types.CHECK_TWO_FACTOR_VERIFICATION);
};

// Plans
export const fetchAllPlans = ({ commit }, plans) => {
  commit(types.FETCH_ALL_PLANS, plans);
};

export const setChosenPlan = ({ commit }, plan) => {
  commit(types.SET_CHOSEN_PLAN, plan);
};

// Organization Types
export const fetchAllOrganizationTypes = ({ commit }, organizationTypes) => {
  commit(types.FETCH_ALL_ORGANIZATION_TYPES, organizationTypes);
};

// Client Types
export const fetchAllClientTypes = ({ commit }, clientTypes) => {
  commit(types.FETCH_ALL_CLIENT_TYPES, clientTypes);
};

// Client
export const fetchClients = ({ commit }, { clients, pagination }) => {
  commit(types.FETCH_CLIENTS, { clients, pagination });
};

export const fetchAllClients = ({ commit }, clients) => {
  commit(types.FETCH_ALL_CLIENTS, clients);
};

export const fetchAllClientOptions = ({ commit }, clients) => {
  commit(types.FETCH_ALL_CLIENT_OPTIONS, clients);
};

export const resetClients = ({ commit }) => {
  commit(types.RESET_CLIENTS);
};

export const setClientQuery = ({ commit }, { page, limit, search }) => {
  commit(types.CLIENT_QUERY, { page, limit, search });
};

// Client Group
export const fetchPaginatedClientGroups = ({ commit }, { clientGroups, pagination }) => {
  commit(types.FETCH_PAGINATED_CLIENT_GROUPS, { clientGroups, pagination });
};

export const fetchAllClientGroups = ({ commit }, clientGroups) => {
  commit(types.FETCH_ALL_CLIENT_GROUPS, clientGroups);
};

export const updateClientGroup = ({ commit }, clientGroup) => {
  commit(types.UPDATE_CLIENT_GROUP, clientGroup);
};

// Materials
export const fetchPaginatedMaterials = ({ commit }, { materials, pagination }) => {
  commit(types.FETCH_PAGINATED_MATERIALS, { materials, pagination });
};

export const fetchAllMaterials = ({ commit }, materials) => {
  commit(types.FETCH_ALL_MATERIALS, materials);
};

export const setMaterialQuery = ({ commit }, { page, limit, search }) => {
  commit(types.MATERIAL_QUERY, { page, limit, search });
};

export const fetchAllMaterialTypes = ({ commit }, materialTypes) => {
  commit(types.FETCH_ALL_MATERIAL_TYPES, materialTypes);
};

// Batches
export const fetchPaginatedBatches = ({ commit }, { batches, pagination }) => {
  commit(types.FETCH_PAGINATED_BATCHES, { batches, pagination });
};

export const fetchAllBatches = ({ commit }, batches) => {
  commit(types.FETCH_ALL_BATCHES, batches);
};

export const addBatch = ({ commit }, batch) => {
  commit(types.ADD_BATCH, batch);
};

export const setBatchQuery = ({ commit }, { page, limit, search }) => {
  commit(types.BATCH_QUERY, { page, limit, search });
};


// Batch logs

export const fetchPaginatedBatchLogs = ({ commit }, { batchLogs, pagination }) => {
  commit(types.FETCH_PAGINATED_BATCH_LOGS, { batchLogs, pagination });
};

export const fetchAllBatchLogs = ({ commit }, batchLogs) => {
  commit(types.FETCH_ALL_BATCH_LOGS, batchLogs);
};

export const setBatchLogQuery = ({ commit }, { page, limit, search }) => {
  commit(types.BATCH_QUERY, { page, limit, search });
};

// Recipes
export const fetchPaginatedRecipes = ({ commit }, { recipes, pagination }) => {
  commit(types.FETCH_PAGINATED_RECIPES, { recipes, pagination });
};

export const fetchAllRecipes = ({ commit }, recipes) => {
  commit(types.FETCH_ALL_RECIPES, recipes);
};

export const setRecipeQuery = ({ commit }, { page, limit, search }) => {
  commit(types.RECIPE_QUERY, { page, limit, search });
};

// Recipe Types
export const fetchAllRecipeTypes = ({ commit }, recipeTypes) => {
  commit(types.FETCH_ALL_RECIPE_TYPES, recipeTypes);
};

// Recipe Ingredience
export const fetchAllRecipeIngrediences = (({ commit }, recipeIngrediences) => {
  commit(types.FETCH_ALL_RECIPE_INGREDIENCES, recipeIngrediences);
});

export const addRecipeIngredience = ({ commit }, recipeIngredience) => {
  commit(types.ADD_RECIPE_INGREDIENCE, recipeIngredience);
};

export const updateRecipeIngredience = ({ commit }, { recipeIngredience, id }) => {
  commit(types.UPDATE_RECIPE_INGREDIENCE, { recipeIngredience, id });
};

export const removeRecipeIngredience = ({ commit }, id) => {
  commit(types.REMOVE_RECIPE_INGREDIENCE, id);
};

// Batch Ingredience
export const fetchAllBatchIngrediences = (({ commit }, batchIngrediences) => {
  commit(types.FETCH_ALL_BATCH_INGREDIENCES, batchIngrediences);
});

export const addBatchIngredience = ({ commit }, batchIngredience) => {
  commit(types.ADD_BATCH_INGREDIENCE, batchIngredience);
};

export const updateBatchIngredience = ({ commit }, { batchIngredience, id }) => {
  commit(types.UPDATE_BATCH_INGREDIENCE, { batchIngredience, id });
};

export const removeBatchIngredience = ({ commit }, id) => {
  commit(types.REMOVE_BATCH_INGREDIENCE, id);
};

// Recipe Procedure
export const fetchAllRecipeProcedures = (({ commit }, recipeProcedures) => {
  commit(types.FETCH_ALL_RECIPE_PROCEDURES, recipeProcedures);
});

export const addRecipeProcedure = ({ commit }, recipeProcedure) => {
  commit(types.ADD_RECIPE_PROCEDURE, recipeProcedure);
};

export const updateRecipeProcedure = ({ commit }, { recipeProcedure, id }) => {
  commit(types.UPDATE_RECIPE_PROCEDURE, { recipeProcedure, id });
};

export const removeRecipeProcedure = ({ commit }, id) => {
  commit(types.REMOVE_RECIPE_PROCEDURE, id);
};

// Recipe Product
export const fetchAllRecipeProducts = (({ commit }, recipeProducts) => {
  commit(types.FETCH_ALL_RECIPE_PRODUCTS, recipeProducts);
});

export const addRecipeProduct = ({ commit }, recipeProduct) => {
  commit(types.ADD_RECIPE_PRODUCT, recipeProduct);
};

export const removeRecipeProduct = ({ commit }, id) => {
  commit(types.REMOVE_RECIPE_PRODUCT, id);
};

// Recipes
export const fetchPaginatedEquipments = ({ commit }, { equipments, pagination }) => {
  commit(types.FETCH_PAGINATED_EQUIPMENTS, { equipments, pagination });
};

export const fetchAllEquipments = ({ commit }, equipments) => {
  commit(types.FETCH_ALL_EQUIPMENTS, equipments);
};

export const setEquipmentQuery = ({ commit }, { page, limit, search }) => {
  commit(types.EQUIPMENT_QUERY, { page, limit, search });
};

//  Client Contact Type
export const fetchcontactTypes = ({ commit }, contactTypes) => {
  commit(types.FETCH_CONTACT_TYPES, contactTypes);
};

//  Client Address Type
export const fetchaddressTypes = ({ commit }, addressTypes) => {
  commit(types.FETCH_ADDRESS_TYPES, addressTypes);
};

//  Client Contacts
export const setCurrentClientContacts = ({ commit }, clientContacts) => {
  commit(types.SET_CURRENT_CLIENT_CONTACTS, clientContacts);
};

export const addClientContact = ({ commit }, clientContact) => {
  commit(types.ADD_CLIENT_CONTACT, clientContact);
};

export const updateClientContact = ({ commit }, { data, i }) => {
  commit(types.UPDATE_CLIENT_CONTACT, { data, i });
};

export const deleteClientContact = ({ commit }, i) => {
  commit(types.DELETE_CLIENT_CONTACT, i);
};

//  Client Address
export const setCurrentClientAddresses = ({ commit }, clientAddresses) => {
  commit(types.SET_CURRENT_CLIENT_ADDRESSES, clientAddresses);
};

export const addClientAddress = ({ commit }, clientAddress) => {
  commit(types.ADD_CLIENT_ADDRESS, clientAddress);
};

export const updateClientAddress = ({ commit }, { data, i }) => {
  commit(types.UPDATE_CLIENT_ADDRESS, { data, i });
};

export const deleteClientAddress = ({ commit }, i) => {
  commit(types.DELETE_CLIENT_ADDRESS, i);
};

// Product
export const fetchPaginatedProducts = ({ commit }, { products, pagination }) => {
  commit(types.FETCH_PAGINATED_PRODUCTS, { products, pagination });
};

export const fetchAllProducts = ({ commit }, products) => {
  commit(types.FETCH_ALL_PRODUCTS, products);
};

export const fetchAllProductsBasic = ({ commit }, products) => {
  commit(types.FETCH_ALL_PRODUCTS_BASIC, products);
};

export const fetchAllProductTransactions = ({ commit }, transasctions) => {
  commit(types.FETCH_ALL_PRODUCT_TRANSACTIONS, transasctions);
};

export const fetchAllProductTransactionsV2 = ({ commit }, transactionsV2) => {
  commit(types.FETCH_ALL_PRODUCT_TRANSACTIONSV2, transactionsV2);
};

export const fetchProductTransactionsV2 = ({ commit }, { transactionsV2, pagination }) => {
  commit(types.FETCH_PRODUCT_TRANSACTIONSV2, { transactionsV2, pagination });
};

export const setProductQuery = ({ commit }, { page, limit, search, grouping }) => {
  commit(types.PRODUCT_QUERY, { page, limit, search, grouping });
};

export const setProductGrouping = ({ commit }, grouping) => {
  commit(types.SET_PRODUCT_GROUPING, grouping);
};

export const resetProducts = ({ commit }) => {
  commit(types.RESET_PRODUCTS);
};

export const fetchAllProductDeposits = ({ commit }, productDeposits) => {
  commit(types.FETCH_ALL_PRODUCT_DEPOSITS, productDeposits);
};

export const setNullDeposit = ({ commit }) => {
  commit(types.ADD_NULL_DEPOSIT_LIST);
};

export const fetchAllDepositSystems = ({ commit }, depositSystems) => {
  commit(types.FETCH_ALL_DEPOSIT_SYSTEMS, depositSystems);
};

export const setNullDepositSystem = ({ commit }) => {
  commit(types.ADD_NULL_DEPOSIT_SYSTEM);
};

export const fetchAllProductPrice = ({ commit }, productPrices) => {
  commit(types.FETCH_PRODUCT_PRICES, productPrices);
};

export const addProductPrice = ({ commit }, productPrice) => {
  commit(types.ADD_PRODUCT_PRICE, productPrice);
};

export const updateProductPrice = ({ commit }, { index, productPrice }) => {
  commit(types.UPDATE_PRODUCT_PRICE, { index, productPrice });
};

export const removeProductPrice = ({ commit }, index) => {
  commit(types.REMOVE_PRODUCT_PRICE, index);
};

// Product Group
export const fetchPaginatedProductGroups = ({ commit }, { productGroups, pagination }) => {
  commit(types.FETCH_PAGINATED_PRODUCT_GROUPS, { productGroups, pagination });
};

// Product Packaging
export const fetchPaginatedProductPackagings = ({ commit }, { productPackagings, pagination }) => {
  commit(types.FETCH_PAGINATED_PRODUCT_PACKAGINGS, { productPackagings, pagination });
};

// Packaging Materials
export const fetchPackagingMaterials = ({ commit }, packagingMaterials) => {
  commit(types.FETCH_PACKAGING_MATERIALS, packagingMaterials);
};

export const fetchAllProductPackagings = ({ commit }, productPackagings) => {
  commit(types.FETCH_ALL_PRODUCT_PACKAGINGS, productPackagings);
};

export const setNullProductPackagings = ({ commit }) => {
  commit(types.ADD_NULL_PRODUCT_PACKAGINGS);
};

// Packaging Types
export const fetchPackagingTypes = ({ commit }, packagingTypes) => {
  commit(types.FETCH_PACKAGING_TYPES, packagingTypes);
};

// Unit Types
export const fetchUnitTypes = ({ commit }, unitTypes) => {
  commit(types.FETCH_UNIT_TYPES, unitTypes);
};

// Product Types
export const fetchAllProductTypes = ({ commit }, productTypes) => {
  commit(types.FETCH_ALL_PRODUCT_TYPES, productTypes);
};

// Product Subtypes
export const fetchAllProductSubtypes = ({ commit }, productSubtypes) => {
  commit(types.FETCH_ALL_PRODUCT_SUBTYPES, productSubtypes);
};

// Product Recommendation
export const fetchAllProductRecommendations = ({ commit }, productRecommendations) => {
  commit(types.FETCH_ALL_PRODUCT_RECOMMENDATIONS, productRecommendations);
};

// Producers
export const fetchAllProducers = ({ commit }, producers) => {
  commit(types.FETCH_ALL_PRODUCERS, producers);
};

export const fetchAllProductGroups = ({ commit }, productGroups) => {
  commit(types.FETCH_ALL_PRODUCT_GROUPS, productGroups);
};

export const fetchAllProductTags = ({ commit }, productTags) => {
  commit(types.FETCH_ALL_PRODUCT_TAGS, productTags);
};
export const fetchPaginatedProductTags = ({ commit }, { productTags, pagination }) => {
  commit(types.FETCH_PAGINATED_PRODUCT_TAGS, { productTags, pagination });
};

// PRICE FIELDS
export const fetchAllPriceFields = ({ commit }, priceFields) => {
  commit(types.FETCH_ALL_PRICE_FIELDS, priceFields);
};
export const fetchPaginatedPriceFields = ({ commit }, { priceFields, pagination }) => {
  commit(types.FETCH_PAGINATED_PRICE_FIELDS, { priceFields, pagination });
};

// Orders
export const fetchPaginatedOrders = ({ commit }, { orders, pagination }) => {
  commit(types.FETCH_PAGINATED_ORDERS, { orders, pagination });
};

export const fetchAllOrders = ({ commit }, orders) => {
  commit(types.FETCH_ALL_ORDERS, orders);
};

export const fetchOrderTypes = ({ commit }, orderTypes) => {
  commit(types.FETCH_ORDER_TYPES, orderTypes);
};

export const fetchCurrentOrder = ({ commit }, order) => {
  commit(types.FETCH_CURRENT_ORDER, order);
};

export const fetchOrderEvents = ({ commit }, events) => {
  commit(types.FETCH_ORDER_EVENTS, events);
};

export const resetOrders = ({ commit }) => {
  commit(types.RESET_ORDERS);
};

export const setOrderQuery = ({ commit }, { page, limit, search }) => {
  commit(types.ORDER_QUERY, { page, limit, search });
};

// Get user widgets and setting of widgets
export const fetchAvailableWidgets = ({ commit }, availableWidgetsData) => {
  commit(types.FETCH_AVAILABLE_WIDGETS, availableWidgetsData);
};

export const fetchWidgets = ({ commit }, widgetsData) => {
  commit(types.FETCH_USER_WIDGETS, widgetsData);
};

export const fetchBestClientsDataWidgets = ({ commit }, bestClientsWidgetsData) => {
  commit(types.FETCH_BEST_CLIENTS_WIDGETS, bestClientsWidgetsData);
};

export const fetchWaitingProcessedDataWidgets = ({ commit }, waitingProcessedWidgetsData) => {
  commit(types.FETCH_WAITING_PROCESSED_WIDGETS, waitingProcessedWidgetsData);
};

export const fetchWaitingDeiveredDataWidgets = ({ commit }, waitingDeliveredWidgetsData) => {
  commit(types.FETCH_WAITING_DELIVERED_WIDGETS, waitingDeliveredWidgetsData);
};

export const fetchOrderReceivedDataWidgets = ({ commit }, orderReceivedWidgetsData) => {
  commit(types.FETCH_ORDER_RECEIVED_WIDGETS, orderReceivedWidgetsData);
};

export const fetchRevenueDataWidgets = ({ commit }, revenueWidgetsData) => {
  commit(types.FETCH_REVENUE_WIDGETS, revenueWidgetsData);
};

export const fetchPopularProductsDataWidgets = ({ commit }, popularProductsWidgetsData) => {
  commit(types.FETCH_POPULAR_PRODUCTS_WIDGETS, popularProductsWidgetsData);
};

export const fetchSoldProductsDataWidgets = ({ commit }, soldProductsWidgetsData) => {
  commit(types.FETCH_SOLD_PRODUCTS_WIDGETS, soldProductsWidgetsData);
};


// Site languages
export const fetchSiteLanguages = ({ commit }, { siteLanguagesData }) => {
  commit(types.FETCH_SITELANGUAGES, { siteLanguagesData });
};

// Countries
export const fetchCountries = ({ commit }, { countries, pagination }) => {
  commit(types.FETCH_COUNTRIES, { countries, pagination });
};

// Cities
export const fetchCities = ({ commit }, { cities }) => {
  commit(types.FETCH_CITIES, { cities });
};

// Municipalities
export const fetchMunicipalities = ({ commit }, { municipalities }) => {
  commit(types.FETCH_MUNICIPALITIES, { municipalities });
};

// Postals
export const fetchPostals = ({ commit }, { postals }) => {
  commit(types.FETCH_POSTALS, { postals });
};

// Taxes
export const fetchTaxes = ({ commit }, { taxes }) => {
  commit(types.FETCH_TAXES, { taxes });
};

// Business Days
export const fetchBusinessDays = ({ commit }, days) => {
  commit(types.FETCH_BUSINESS_DAYS, days);
};

// Business Hours
export const fetchBusinessHours = ({ commit }, hours) => {
  commit(types.FETCH_BUSINESS_HOURS, hours);
};

export const storeBusinessHour = ({ commit }, b) => {
  commit(types.STORE_BUSINESS_HOUR, b);
};

export const destroyBusinessHour = ({ commit }, id) => {
  commit(types.DESTROY_BUSINESS_HOUR, id);
};

// Business Hour Exceptions
export const fetchBusinessHourExceptions = ({ commit }, hours) => {
  commit(types.FETCH_BUSINESS_HOUR_EXCEPTIONS, hours);
};

export const storeBusinessHourException = ({ commit }, e) => {
  commit(types.STORE_BUSINESS_HOUR_EXCEPTION, e);
};

export const destroyBusinessHourException = ({ commit }, id) => {
  commit(types.DESTROY_BUSINESS_HOUR_EXCEPTION, id);
};

// Bills
export const fetchPaginatedBills = ({ commit }, { bills, pagination }) => {
  commit(types.FETCH_PAGINATED_BILLS, { bills, pagination });
};

export const fetchBillStatuses = ({ commit }, statuses) => {
  commit(types.FETCH_BILL_STATUSES, statuses);
};

export const fetchBillTypes = (({ commit }, billTypes) => {
  commit(types.FETCH_BILL_TYPES, billTypes);
});

export const fetchCurrentBill = ({ commit }, bill) => {
  commit(types.FETCH_CURRENT_BILL, bill);
};

export const setBillQuery = ({ commit }, { page, limit, search }) => {
  commit(types.BILL_QUERY, { page, limit, search });
};

export const fetchAllCreditNoteReasons = ({ commit }, creditNoteReasons) => {
  commit(types.FETCH_ALL_CREDIT_NOTE_REASONS, creditNoteReasons);
};

export const fetchCurrentCreditNoteReason = ({ commit }, creditNoteReason) => {
  commit(types.FETCH_CURRENT_CREDIT_NOTE_REASON, creditNoteReason);
};

// Order Product
export const fetchAllOrderProducts = (({ commit }, orderProducts) => {
  commit(types.FETCH_ALL_ORDER_PRODUCTS, orderProducts);
});

export const addOrderProduct = ({ commit }, orderProduct) => {
  commit(types.ADD_ORDER_PRODUCT, orderProduct);
};

export const updateOrderProduct = ({ commit }, { orderProduct, id }) => {
  commit(types.UPDATE_ORDER_PRODUCT, { orderProduct, id });
};

export const removeOrderProduct = ({ commit }, id) => {
  commit(types.REMOVE_ORDER_PRODUCT, id);
};

// Bill Product
export const fetchAllBillProducts = (({ commit }, billProducts) => {
  commit(types.FETCH_ALL_BILL_PRODUCTS, billProducts);
});

export const addBillProduct = ({ commit }, billProduct) => {
  commit(types.ADD_BILL_PRODUCT, billProduct);
};

export const updateBillProduct = ({ commit }, { billProduct, id }) => {
  commit(types.UPDATE_BILL_PRODUCT, { billProduct, id });
};

export const removeBillProduct = ({ commit }, id) => {
  commit(types.REMOVE_BILL_PRODUCT, id);
};

// Credit Note Product
export const fetchAllCreditNoteProducts = (({ commit }, creditNoteProducts) => {
  commit(types.FETCH_ALL_CREDIT_NOTE_PRODUCTS, creditNoteProducts);
});

export const addCreditNoteProduct = ({ commit }, creditNoteProduct) => {
  commit(types.ADD_CREDIT_NOTE_PRODUCT, creditNoteProduct);
};

export const updateCreditNoteProduct = ({ commit }, { creditNoteProduct, id }) => {
  commit(types.UPDATE_CREDIT_NOTE_PRODUCT, { creditNoteProduct, id });
};

export const removeCreditNoteProduct = ({ commit }, id) => {
  commit(types.REMOVE_CREDIT_NOTE_PRODUCT, id);
};

// Edi Order
export const fetchAllEdiOrders = ({ commit }, ediOrders) => {
  commit(types.FETCH_ALL_EDI_ORDERS, ediOrders);
};

export const fetchPaginatedEdiOrders = ({ commit }, { ediOrders, pagination }) => {
  commit(types.FETCH_PAGINATED_EDI_ORDERS, { ediOrders, pagination });
};

export const fetchCurrentEdiOrder = ({ commit }, ediOrder) => {
  commit(types.FETCH_CURRENT_EDI_ORDER, ediOrder);
};

// Edi Order Item
export const fetchAllEdiOrderItems = (({ commit }, ediOrderItems) => {
  commit(types.FETCH_ALL_EDI_ORDER_ITEMS, ediOrderItems);
});

export const updateEdiOrderItem = ({ commit }, { ediOrderItem, id }) => {
  commit(types.UPDATE_EDI_ORDER_ITEM, { ediOrderItem, id });
};

// Message template types
export const fetchAllMessageTemplateTypes = ({ commit }, templateTypes) => {
  commit(types.FETCH_ALL_MESSAGE_TEMPLATE_TYPES, templateTypes);
};

// Accounting providers
export const fetchAllAccountingProviders = ({ commit }, accountingProviders) => {
  commit(types.FETCH_ALL_ACCOUNTING_PROVIDERS, accountingProviders);
};

// Chart of accounts
export const fetchAllChartOfAccounts = ({ commit }, chartOfAccounts) => {
  commit(types.FETCH_ALL_CHART_OF_ACCOUNTS, chartOfAccounts);
};

export const addChartOfAccountsItem = ({ commit }, chartOfAccounts) => {
  commit(types.ADD_CHART_OF_ACCOUNTS_ITEM, chartOfAccounts);
};

export const updateChartOfAccountsItem = ({ commit }, { data, id }) => {
  commit(types.UPDATE_CHART_OF_ACCOUNTS_ITEM, { data, id });
};

export const removeChartOfAccountsItem = ({ commit }, id) => {
  commit(types.REMOVE_CHART_OF_ACCOUNTS_ITEM, id);
};

// Campaigns
export const fetchPaginatedCampaigns = ({ commit }, { campaigns, pagination }) => {
  commit(types.FETCH_PAGINATED_CAMPAIGNS, { campaigns, pagination });
};

export const fetchCampaignTypes = (({ commit }, campaignTypes) => {
  commit(types.FETCH_CAMPAIGN_TYPES, campaignTypes);
});

// Supplier
export const FetchAllSuppliers = ({ commit }, suppliers) => {
  commit(types.FETCH_ALL_SUPPLIERS, suppliers);
};

export const fetchPaginatedSuppliers = ({ commit }, { suppliers, pagination }) => {
  commit(types.FETCH_PAGINATE_SUPPLIERS, { suppliers, pagination });
};

export const fetchCurrentSupplier = ({ commit }, supplier) => {
  commit(types.FETCH_CURRENT_SUPPLIER, supplier);
};

// Warehouse
export const FetchAllWarehouses = ({ commit }, warehouses) => {
  commit(types.FETCH_ALL_WAREHOUSES, warehouses);
};

export const fetchPaginatedWarehouses = ({ commit }, { warehouses, pagination }) => {
  commit(types.FETCH_PAGINATE_WAREHOUSES, { warehouses, pagination });
};

export const fetchCurrentWarehouse = ({ commit }, warehouse) => {
  commit(types.FETCH_CURRENT_WAREHOUSE, warehouse);
};

// export const fetchCurrentWarehouseProducts = ({ commit }, products) => {
//   commit(types.FETCH_CURRENT_WAREHOUSE_PRODUCTS, products);
// };

export const fetchPaginatedWarehouseProducts = ({ commit }, { products, pagination }) => {
  commit(types.FETCH_PAGINATE_WAREHOUSE_PRODUCTS, { products, pagination });
};

export const fetchAllWarehouseTransactions = ({ commit }, transasctions) => {
  commit(types.FETCH_ALL_WAREHOUSE_TRANSACTIONS, transasctions);
};

// TransactionsV2
export const fetchAllWarehouseTransactionsV2 = ({ commit }, transactionsV2All) => {
  commit(types.FETCH_ALL_WAREHOUSE_TRANSACTIONSV2, transactionsV2All);
};
export const fetchPaginatedWarehouseTransactionsV2 = ({ commit }, { transactions, pagination }) => {
  commit(types.FETCH_PAGINATE_WAREHOUSE_TRANSACTIONSV2, { transactions, pagination });
};

// Unit Of Measures
export const FetchAllUnitOfMeasures = ({ commit }, unitOfMeasures) => {
  commit(types.FETCH_ALL_UNIT_OF_MEASURES, unitOfMeasures);
};

export const fetchPaginatedUnitOfMeasures = ({ commit }, { unitOfMeasures, pagination }) => {
  commit(types.FETCH_PAGINATE_UNIT_OF_MEASURES, { unitOfMeasures, pagination });
};

export const fetchCurrentUnitOfMeasure = ({ commit }, unitOfMeasure) => {
  commit(types.FETCH_CURRENT_UNIT_OF_MEASURES, unitOfMeasure);
};

// Stocks
export const FetchAllStocks = ({ commit }, stocks) => {
  commit(types.FETCH_ALL_STOCKS, stocks);
};

export const fetchPaginatedStocks = ({ commit }, { stocks, pagination }) => {
  commit(types.FETCH_PAGINATE_STOCKS, { stocks, pagination });
};

export const fetchCurrentStock = ({ commit }, stock) => {
  commit(types.FETCH_CURRENT_STOCK, stock);
};

export const allCurrentStockProducts = ({ commit }, products) => {
  commit(types.FETCH_CURRENT_STOCK_PRODUCTS, products);
};

export const PushToStockProducts = ({ commit }, product) => {
  commit(types.PUSH_TO_STOCK_PRODUCTS, product);
};

export const setStockSelectedWarehouse = ({ commit }, warehouseId) => {
  commit(types.SET_STOCK_SELECTED_WAREHOUSE, warehouseId);
};

export const deleteStockProduct = ({ commit }, i) => {
  commit(types.DELETE_TO_STOCK_PRODUCTS, i);
};

export const UpdateToStockProducts = ({ commit }, { data, i }) => {
  commit(types.UPDATE_TO_STOCK_PRODUCTS, { data, i });
};

export const DeleteFromStockProductsCustom = ({ commit }, i) => {
  commit(types.DELETE_FROM_STOCK_PRODUCTS_CUSTOM, i);
};

export const EditToStockProducts = ({ commit }, { data, i }) => {
  commit(types.EDIT_TO_STOCK_PRODUCTS, { data, i });
};

export const allCurrentStockProductsCustom = ({ commit }, products) => {
  commit(types.FETCH_CURRENT_STOCK_PRODUCTS_CUSTOM, products);
};

export const PushToStockProductsCustom = ({ commit }, product) => {
  commit(types.PUSH_TO_STOCK_PRODUCTS_CUSTOM, product);
};

export const RefreshStockProducts = ({ commit }) => {
  commit(types.REFRESH_STOCK_PRODUCTS);
};

export const RefreshStockProductsCustom = ({ commit }) => {
  commit(types.REFRESH_STOCK_PRODUCTS_CUSTOM);
};

// Adjustment
export const FetchAllAdjustments = ({ commit }, adjustments) => {
  commit(types.FETCH_ALL_ADJUSTMENTS, adjustments);
};

export const fetchPaginatedAdjustments = ({ commit }, { adjustments, pagination }) => {
  commit(types.FETCH_PAGINATE_ADJUSTMENTS, { adjustments, pagination });
};

export const fetchCurrentAdjustment = ({ commit }, adjustment) => {
  commit(types.FETCH_CURRENT_ADJUSTMENT, adjustment);
};

// Purchase
export const FetchAllPurchases = ({ commit }, purchases) => {
  commit(types.FETCH_ALL_PURCHASES, purchases);
};

export const fetchPaginatedPurchases = ({ commit }, { purchases, pagination }) => {
  commit(types.FETCH_PAGINATE_PURCHASES, { purchases, pagination });
};

export const fetchCurrentPurchase = ({ commit }, purchase) => {
  commit(types.FETCH_CURRENT_PURCHASE, purchase);
};

export const fetchPurchaseStatuses = ({ commit }, statuses) => {
  commit(types.FETCH_PURCHASE_STATUSES, statuses);
};

// View
export const setView = ({ commit }, view) => {
  commit(types.TYPE_OF_VIEW, view);
};
export const setOrderTypeView = ({ commit }, orderViewType) => {
  commit(types.TYPE_OF_ORDER_VIEW, orderViewType);
};
// Shipping Providers
export const FetchAllShippingProviders = ({ commit }, shippingProviders) => {
  commit(types.FETCH_ALL_SHIPPING_PROVIDERS, shippingProviders);
};

export const fetchCurrentShippingProvider = ({ commit }, shippingProvider) => {
  commit(types.FETCH_CURRENT_SHIPPING_PROVIDER, shippingProvider);
};

// productFlow
export const FetchAllproductFlows = ({ commit }, productFlows) => {
  commit(types.FETCH_ALL_PRODUCTFLOWS, productFlows);
};

export const fetchPaginatedproductFlows = ({ commit }, { productFlows, pagination }) => {
  commit(types.FETCH_PAGINATE_PRODUCTFLOWS, { productFlows, pagination });
};

export const fetchCurrentproductFlow = ({ commit }, productFlow) => {
  commit(types.FETCH_CURRENT_PRODUCTFLOW, productFlow);
};


export const fetchproductFlowOrders = ({ commit }, orders) => {
  commit(types.FETCH_ALL_PRODUCTFLOW_ORDERS, orders);
};

export const fetchExciseGroup = ({ commit }, { exciseGroups }) => {
  commit(types.FETCH_EXCISE_GROUPS, { exciseGroups });
};

export const fetchExcisePackagingGroup = ({ commit }, { excisePackagingGroups }) => {
  commit(types.FETCH_EXCISE_PACKAGING_GROUPS, { excisePackagingGroups });
};

export const fetchExciseBasicGroup = ({ commit }, { exciseBasicGroups }) => {
  commit(types.FETCH_EXCISE_BASIC, { exciseBasicGroups });
};

export const setNullOnExciseGroup = ({ commit }) => {
  commit(types.ADD_NULL_TO_EXCISE_GROUPS_LIST);
};

export const fetchAdditionalCode = ({ commit }, { exciseAdditionals }) => {
  commit(types.FETCH_ADDITIONAL_CODE, { exciseAdditionals });
};

// Organization Members
export const fetchAllOrganizationMembers = ({ commit }, organizationMembers) => {
  commit(types.FETCH_ALL_ORGANIZATION_MEMBERS, organizationMembers);
};
export const addOrganizationMember = ({ commit }, organizationMember) => {
  commit(types.ADD_ORGANIZATION_MEMBER, organizationMember);
};

// Organization Member Product Businesshours
export const fetchAllOrganizationMemberProductBusinessHours = ({ commit }, businesshours) => {
  commit(types.FETCH_ALL_ORGANIZATION_MEMBER_PRODUCT_BUSINESSHOURS, businesshours);
};

// Organization Member Bookings
export const fetchAllOrganizationMemberBookings = ({ commit }, organizationMemberBookings) => {
  commit(types.FETCH_ALL_ORGANIZATION_MEMBER_BOOKINGS, organizationMemberBookings);
};
export const addOrganizationMemberBooking = ({ commit }, organizationMemberBooking) => {
  commit(types.ADD_ORGANIZATION_MEMBER_BOOKING, organizationMemberBooking);
};

// MODULES
export const fetchAllModules = ({ commit }, modules) => {
  commit(types.FETCH_ALL_MODULES, modules);
};

// Transaction Types
export const fetchAllTransactionTypes = ({ commit }, transactionTypes) => {
  commit(types.FETCH_ALL_TRANSACTION_TYPES, transactionTypes);
};

// Transfer
export const FetchAllTransfers = ({ commit }, transfers) => {
  commit(types.FETCH_ALL_TRANSFERS, transfers);
};

export const fetchPaginatedTransfers = ({ commit }, { transfers, pagination }) => {
  commit(types.FETCH_PAGINATE_TRANSFERS, { transfers, pagination });
};

export const fetchCurrentTransfer = ({ commit }, transfer) => {
  commit(types.FETCH_CURRENT_TRANSFER, transfer);
};

// License
export const fetchAllLicenses = ({ commit }, licenses) => {
  commit(types.FETCH_ALL_LICENSES, licenses);
};
export const fetchAllLicenseTypes = ({ commit }, licenseTypes) => {
  commit(types.FETCH_ALL_LICENSE_TYPES, licenseTypes);
};
export const setNullLicenseType = ({ commit }) => {
  commit(types.ADD_NULL_LICENSE_TYPE);
};
export const fetchAllLicensePermits = ({ commit }, licensePermits) => {
  commit(types.FETCH_ALL_LICENSE_PERMITS, licensePermits);
};
export const fetchAllLicensePermitTypes = ({ commit }, licensePermitTypes) => {
  commit(types.FETCH_ALL_LICENSE_PERMIT_TYPES, licensePermitTypes);
};
export const fetchAllLicenseGroups = ({ commit }, licenseGroups) => {
  commit(types.FETCH_ALL_LICENSE_GROUPS, licenseGroups);
};
export const fetchAllLicensePermitGroups = ({ commit }, licensePermitGroups) => {
  commit(types.FETCH_ALL_LICENSE_PERMIT_GROUPS, licensePermitGroups);
};

// Excise Periods
export const fetchPaginatedExcisePeriods = ({ commit }, { excisePeriods, pagination }) => {
  commit(types.FETCH_PAGINATED_EXCISE_PERIODS, { excisePeriods, pagination });
};

// Subscribe List
export const fetchAllSubscriberList = ({ commit }, subscriberList) => {
  commit(types.FETCH_ALL_SUBSCRIBER_LIST, subscriberList);
};
export const fetchPaginatedSubscriberList = ({ commit }, { subscriberList, pagination }) => {
  commit(types.FETCH_PAGINATED_SUBSCRIBER_LIST, { subscriberList, pagination });
};
export const fetchCurrentSubscriberList = ({ commit }, subscriberList) => {
  commit(types.FETCH_CURRENT_SUBSCRIBER_LIST, subscriberList);
};
export const setchModifiedClientGroup = ({ commit }, modifiedClientGroup) => {
  commit(types.SET_MODIFIED_CLIENT_GROUP, modifiedClientGroup);
};
export const setCancelClientGroupAdd = ({ commit }, cancelClientGroupAdd) => {
  commit(types.SET_CANCEL_CLIENT_GROUP_ADD, cancelClientGroupAdd);
};

// Subscriber
export const fetchAllSubscriber = ({ commit }, subscriber) => {
  commit(types.FETCH_ALL_SUBSCRIBER, subscriber);
};
export const fetchPaginatedSubscriber = ({ commit }, { subscriber, pagination }) => {
  commit(types.FETCH_PAGINATED_SUBSCRIBER, { subscriber, pagination });
};
export const fetchAllPackageUnitTypes = (({ commit }, packageUnitTypes) => {
  commit(types.FETCH_ALL_PACKAGE_UNIT_TYPES, packageUnitTypes);
});

export const fetchAllPackages = (({ commit }, packages) => {
  commit(types.FETCH_ALL_PACKAGES, packages);
});

export const fetchAllPackageOrderProducts = (({ commit }, packageOrderProducts) => {
  commit(types.FETCH_ALL_PACKAGE_ORDER_PRODUCTS, packageOrderProducts);
});

// Get app toast resp
export const fetchToastResp = ({ commit }, appToastData) => {
  commit(types.FETCH_USER_APP_TOAST, appToastData);
};

// Get app version
export const fetchLatestVersion = ({ commit }, appVersionData) => {
  commit(types.FETCH_USER_APP_VERSION, appVersionData);
};

// Partners
export const fetchAllPartners = ({ commit }, partners) => {
  commit(types.FETCH_ALL_PARTNERS, partners);
};

// Order Pickups
export const fetchPaginatedOrderPickups = ({ commit }, { orderPickups, pagination }) => {
  commit(types.FETCH_PAGINATED_ORDER_PICKUPS, { orderPickups, pagination });
};

export const fetchAllOrderPickups = ({ commit }, orderPickups) => {
  commit(types.FETCH_ALL_ORDER_PICKUPS, orderPickups);
};

export const fetchOrderPickupTypes = ({ commit }, orderPickupTypes) => {
  commit(types.FETCH_ORDER_PICKUP_TYPES, orderPickupTypes);
};

export const fetchCurrentOrderPickup = ({ commit }, orderPickup) => {
  commit(types.FETCH_CURRENT_ORDER_PICKUP, orderPickup);
};

export const fetchOrderPickupEvents = ({ commit }, events) => {
  commit(types.FETCH_ORDER_PICKUP_EVENTS, events);
};

export const resetOrderPickups = ({ commit }) => {
  commit(types.RESET_ORDER_PICKUPS);
};

export const setOrderPickupQuery = ({ commit }, { page, limit, search }) => {
  commit(types.ORDER_PICKUP_QUERY, { page, limit, search });
};

//  Payment methods
export const fetchPaymentMethods = ({ commit }, paymentMethods) => {
  commit(types.FETCH_PAYMENT_METHODS, paymentMethods);
};

// languages
export const fetchLanguages = ({ commit }, languages) => {
  commit(types.FETCH_LANGUAGES, languages);
};

// Currency
export const fetchCurrencies = ({ commit }, currencies) => {
  commit(types.FETCH_CURRENCIES, currencies);
};

// Project
export const fetchProjects = ({ commit }, { projects, pagination }) => {
  commit(types.FETCH_PROJECTS, { projects, pagination });
};

export const fetchAllProjects = ({ commit }, projects) => {
  commit(types.FETCH_ALL_PROJECTS, projects);
};

export const resetProjects = ({ commit }) => {
  commit(types.RESET_PROJECTS);
};

// Inventory bridge handoff (Phase E/F)
export const setBridgeHandoff = ({ commit }, payload) => {
  commit(types.SET_BRIDGE_HANDOFF, payload);
};



// WEBPACK FOOTER //
// ./src/app/store/actions.js